import * as React from 'react';
import { Path } from 'react-native-svg';

function Horns() {
  return (
    <>
      <Path
        d="M117.3 49.23c1.17-5.37 1-11-1.4-15.31-4.94 5.72-6.66 13.3-14.68 16.2-1.64.59-3.46 1-4.67 2.19-1.79 1.85-1.5 4.85-.79 7.32.67 2.31 1.71 4.67 3.71 6a7.79 7.79 0 007.63.13 15.18 15.18 0 005.68-5.49 33.24 33.24 0 004.52-11.04z"
        fill="#e21013"
      />
      <Path
        d="M111.47 52.2A14.86 14.86 0 00116 39.85a16.36 16.36 0 01-2.21 14.31 1.51 1.51 0 01-2.48-1.73 1.71 1.71 0 01.16-.23z"
        fill="#fff"
      />
      <Path
        d="M25.81 48.37c-1.17-5.37-1-11 1.4-15.31 4.94 5.72 6.66 13.29 14.68 16.19 1.63.59 3.46 1 4.66 2.2 1.8 1.85 1.51 4.84.8 7.32-.67 2.3-1.71 4.66-3.71 6a7.79 7.79 0 01-7.63.13 15.26 15.26 0 01-5.68-5.49 33.42 33.42 0 01-4.52-11.04z"
        fill="#e21013"
      />
      <Path
        d="M30.2 54.15A16.36 16.36 0 0128 39.84a14.86 14.86 0 004.48 12.36 1.51 1.51 0 11-2 2.22 1.21 1.21 0 01-.21-.24z"
        fill="#fff"
      />
    </>
  );
}

export default Horns;
